export interface LiveItem {
  id: string;
  time: string;
  day: string;
  type: string;
  title: string;
  summary: string;
  heat: number;
  status: "已证实" | "多方讨论" | "待核实";
  tags: string[];
  image?: string;
}

export const liveFeed: LiveItem[] = [
  {
    id: "lf-01",
    time: "10:26",
    day: "今天",
    type: "影视",
    title: "《长夜灯》官宣主演阵容，双主角设定引发第一波讨论",
    summary:
      "剧方在上午放出首张角色海报，两位主角的番位顺序成为评论区焦点。片方暂未回应番位争议，只提到剧本围读已经完成，预计下月进入正式拍摄。",
    heat: 9876,
    status: "已证实",
    tags: ["新剧官宣", "角色海报"],
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20teal%20and%20amber%20gradient%20poster%20background%20with%20soft%20spotlight%20and%20film%20strip%20motif%2C%20moody%20editorial%20style%2C%20no%20text&width=800&height=600&seq=lf-film-poster-01&orientation=landscape",
  },
  {
    id: "lf-02",
    time: "09:58",
    day: "今天",
    type: "娱乐",
    title: "歌手苏芮安巡演加场，三座城市同步开票",
    summary:
      "官方票务页更新了加场信息，三站均在同一天的下午两点开票。上一轮开票时多个价位被秒空，这次加场被粉丝视作补票机会。",
    heat: 8420,
    status: "已证实",
    tags: ["巡演加场", "开票提醒"],
    image:
      "https://readdy.ai/api/search-image?query=Concert%20stage%20with%20warm%20coral%20and%20gold%20lighting%2C%20crowd%20silhouettes%20and%20glowing%20beams%2C%20energetic%20live%20music%20atmosphere%2C%20abstract%20editorial%20photography&width=800&height=600&seq=lf-concert-stage-02&orientation=landscape",
  },
  {
    id: "lf-03",
    time: "09:31",
    day: "今天",
    type: "科技",
    title: "星河科技发布会预告：新一代随身设备主打全天续航",
    summary:
      "预热海报只留了一句'把一天的电量装进掌心'。渠道商透露首批备货量不小，圈内猜测定价会落在中端区间，正式参数要等发布会当天。",
    heat: 7315,
    status: "多方讨论",
    tags: ["新品预热", "发布会"],
  },
  {
    id: "lf-04",
    time: "08:47",
    day: "今天",
    type: "体育",
    title: "联赛第 12 轮爆冷，卫冕队伍客场被逼平",
    summary:
      "上半场领先一球后，卫冕队伍在下半场被对手连续压制，补时阶段丢球。赛后主帅承认体能分配出了问题，但强调联赛还长，不会调整争冠目标。",
    heat: 6890,
    status: "已证实",
    tags: ["联赛", "爆冷"],
  },
  {
    id: "lf-05",
    time: "23:12",
    day: "昨天",
    type: "娱乐",
    title: "男团 NEON 深夜回应成员调整，称是正常规划",
    summary:
      "组合官方账号在深夜发了一条简短说明，回应近期有关成员变动的传闻，表示属于正常的阶段规划，后续活动照常推进。评论区仍在追问具体安排。",
    heat: 9120,
    status: "多方讨论",
    tags: ["组合动态", "官方回应"],
  },
  {
    id: "lf-06",
    time: "22:40",
    day: "昨天",
    type: "影视",
    title: "综艺《星河夜话》新一期剪辑顺序被吐槽",
    summary:
      "有观众统计了整期片段的播放次序，认为关键互动被剪散，导致剧情线看起来不连贯。节目组尚未回应，话题已进入当天的讨论榜前列。",
    heat: 6240,
    status: "多方讨论",
    tags: ["综艺", "剪辑争议"],
  },
  {
    id: "lf-07",
    time: "21:05",
    day: "昨天",
    type: "社会",
    title: "城市夜跑活动报名开启，多个路段将临时管制",
    summary:
      "主办方发布了路线图与交通提示，活动当晚部分主干道会分时段限行。想参加的人需要在开放时间内完成线上报名，名额采取先到先得。",
    heat: 3980,
    status: "已证实",
    tags: ["城市活动", "出行提醒"],
  },
  {
    id: "lf-08",
    time: "19:52",
    day: "昨天",
    type: "科技",
    title: "开源社区更新重磅版本，开发者连夜讨论迁移方案",
    summary:
      "新版本调整了默认配置，部分旧项目需要手动兼容。讨论区里已经有人贴出迁移清单，也有人建议先观望再升级。",
    heat: 5410,
    status: "已证实",
    tags: ["开源", "版本更新"],
  },
  {
    id: "lf-09",
    time: "18:20",
    day: "昨天",
    type: "娱乐",
    title: "疑似片场路透流出，作品方提醒勿传播未公开物料",
    summary:
      "一组模糊的现场照片在社交平台流传，作品方简短提醒大家不要传播未公开的物料，以免影响拍摄秩序。照片真实性与拍摄时间目前无法确认。",
    heat: 7760,
    status: "待核实",
    tags: ["路透", "拍摄现场"],
  },
  {
    id: "lf-10",
    time: "16:38",
    day: "昨天",
    type: "影视",
    title: "暑期档复盘：中小成本片靠口碑长线跑出黑马",
    summary:
      "盘点数据显示，几部开局排片不高的作品凭借口碑延长了放映周期，最终成绩反超同档期大制作。业内把这类走势称作'长尾逆袭'。",
    heat: 4520,
    status: "已证实",
    tags: ["暑期档", "票房复盘"],
  },
];